import { render, staticRenderFns } from "./createJournal.vue?vue&type=template&id=63a484d2&scoped=true"
import script from "./createJournal.vue?vue&type=script&lang=js"
export * from "./createJournal.vue?vue&type=script&lang=js"
import style0 from "./createJournal.vue?vue&type=style&index=0&id=63a484d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a484d2",
  null
  
)

export default component.exports